// Generated by @cogo/headless-core run-component-event-capability-projection.ts.
// Do not edit this file by hand; update renderer capability facts or ontology interaction policy, then regenerate.
export const COMPONENT_EVENT_CAPABILITIES_V1 = {
  "schemaVersion": "1.0.0",
  "rendererPackage": "@cogo/react-renderer-v2",
  "provenance": {
    "ontologyPath": "packages/cogo-kg-browser/fixtures/ui-ontology-v1.ttl",
    "ontologySha256": "sha256:ca6c99a579962268d653a0b51f561d49f53047e4d58f621b3dfd161b0b06d12f",
    "eventOntologyPath": "packages/cogo-kg-browser/fixtures/events-v1.ttl",
    "eventOntologySha256": "sha256:ab846889e503127c8e27ca1b5b01185d263fc9c650b8c95b41c778a15b433877",
    "componentCatalogPath": "packages/cogo-validator/ontology/component-capabilities.json",
    "componentCatalogSha256": "sha256:2de97be3eae058544fd62c81e1b5e2edda30ee08fc63bfbb07f4b48e72d0c314"
  },
  "components": {
    "button": {
      "events": [
        "tap"
      ],
      "primaryEvent": "tap",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/lib/preset-utils.ts",
          "sourceSymbol": "stripPresetConflicts"
        },
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/button-renderer.tsx",
          "sourceSymbol": "ButtonRenderer"
        }
      ]
    },
    "calendar": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/calendar-renderer.tsx",
          "sourceSymbol": "CalendarRenderer"
        }
      ]
    },
    "card": {
      "events": [
        "tap"
      ],
      "primaryEvent": "tap",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/card-renderer.tsx",
          "sourceSymbol": "CardRenderer"
        }
      ]
    },
    "chart-line": {
      "events": [],
      "primaryEvent": null,
      "hostKind": "non-interactive",
      "focusStrategy": "none",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/chart-renderer.tsx",
          "sourceSymbol": "ChartRenderer"
        }
      ]
    },
    "checkbox": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/checkbox-renderer.tsx",
          "sourceSymbol": "CheckboxRenderer"
        }
      ]
    },
    "combobox": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/combobox-renderer.tsx",
          "sourceSymbol": "ComboboxRenderer"
        }
      ]
    },
    "container": {
      "events": [],
      "primaryEvent": null,
      "hostKind": "non-interactive",
      "focusStrategy": "none",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/container-renderer.tsx",
          "sourceSymbol": "ContainerRenderer"
        },
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/element-renderer.tsx",
          "sourceSymbol": "ElementRenderer"
        }
      ]
    },
    "data-table": {
      "events": [
        "rowClick",
        "cellChange"
      ],
      "primaryEvent": "rowClick",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/data-table-renderer.tsx",
          "sourceSymbol": "DataTableRenderer"
        }
      ]
    },
    "date-picker": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/date-picker-renderer.tsx",
          "sourceSymbol": "DatePickerRenderer"
        }
      ]
    },
    "form": {
      "events": [
        "submit"
      ],
      "primaryEvent": "submit",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/form-renderer.tsx",
          "sourceSymbol": "FormRenderer"
        }
      ]
    },
    "input": {
      "events": [
        "change",
        "keydown"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/input-renderer.tsx",
          "sourceSymbol": "InputRenderer"
        }
      ]
    },
    "list": {
      "events": [],
      "primaryEvent": null,
      "hostKind": "non-interactive",
      "focusStrategy": "none",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/list-renderer.tsx",
          "sourceSymbol": "ListRenderer"
        }
      ]
    },
    "map": {
      "events": [],
      "primaryEvent": null,
      "hostKind": "non-interactive",
      "focusStrategy": "none",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/map-renderer.tsx",
          "sourceSymbol": "MapRenderer"
        }
      ]
    },
    "radio": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/radio-renderer.tsx",
          "sourceSymbol": "RadioRenderer"
        }
      ]
    },
    "select": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/select-renderer.tsx",
          "sourceSymbol": "SelectRenderer"
        }
      ]
    },
    "slider": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/slider-renderer.tsx",
          "sourceSymbol": "SliderRenderer"
        }
      ]
    },
    "switch": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/switch-renderer.tsx",
          "sourceSymbol": "SwitchRenderer"
        }
      ]
    },
    "table": {
      "events": [
        "rowClick"
      ],
      "primaryEvent": "rowClick",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/table-renderer.tsx",
          "sourceSymbol": "TableRenderer"
        }
      ]
    },
    "text": {
      "events": [],
      "primaryEvent": null,
      "hostKind": "non-interactive",
      "focusStrategy": "none",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/text-renderer.tsx",
          "sourceSymbol": "TextRenderer"
        }
      ]
    },
    "textarea": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/textarea-renderer.tsx",
          "sourceSymbol": "TextareaRenderer"
        }
      ]
    },
    "toggle": {
      "events": [
        "change",
        "tap"
      ],
      "primaryEvent": "change",
      "hostKind": "native-control",
      "focusStrategy": "focus-visible",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/toggle-renderer.tsx",
          "sourceSymbol": "ToggleRenderer"
        }
      ]
    },
    "toggle-group": {
      "events": [
        "change"
      ],
      "primaryEvent": "change",
      "hostKind": "composite-proxy",
      "focusStrategy": "focus-within",
      "evidence": [
        {
          "sourceFile": "packages/cogo-react-renderer/src/renderers/toggle-group-renderer.tsx",
          "sourceSymbol": "ToggleGroupRenderer"
        }
      ]
    }
  }
} as const
